import AjaxUtils from './ajaxUtils';

const SERVER = envConfig.OUTBOUND_SERVER_URL;

const createURL = (queryStringParams, integrationName) => Object.entries(queryStringParams).reduce(
  (currentURL, [key, value]) => value ? `${currentURL}&${key}=${encodeURIComponent(value)}` : currentURL,
  `/v2/account-integrations-save-to?integrationName=${integrationName}`
);

const saveToIntegrationBuilder = integrationName => async options => {
  const { contact, ...queryStringParams } = options;
  const url = createURL(queryStringParams, integrationName);

  return AjaxUtils.post(url, contact);
};

const saveToSalesforce = saveToIntegrationBuilder('salesforce');
const saveToZoho = saveToIntegrationBuilder('zoho');
const saveToHubspot = saveToIntegrationBuilder('hubspot');
const saveToOutreach = saveToIntegrationBuilder('outreach');
const saveToSalesloft = saveToIntegrationBuilder('salesloft');
const saveToPipedrive = saveToIntegrationBuilder('pipedrive');

const getOutreachSequences = async () => {
  try {
    const url = '/v2/account-integrations-save-to/outreach?objectName=sequence';

    return AjaxUtils.get(url);
  } catch (e) {
    return undefined;
  }
};

const getSalesloftCadences = async () => {
  try {
    const url = '/v2/account-integrations-save-to/salesloft?objectName=cadences';

    return AjaxUtils.get(url);
  } catch (e) {
    return undefined;
  }
};

const getAccountIntegrations = async () => {
  try {
    return AjaxUtils.get(`${SERVER}/v2/account-integrations?$eager=integration`, true);
  } catch (e) {
    return undefined;
  }
};

const getUserAllActiveIntegrations = async () => AjaxUtils.get('/api/v1/lusha-integrations/all-user-active-integrations');

export {
  getAccountIntegrations,
  getOutreachSequences,
  getSalesloftCadences,
  getUserAllActiveIntegrations,
  saveToHubspot,
  saveToOutreach,
  saveToPipedrive,
  saveToSalesforce,
  saveToSalesloft,
  saveToZoho,
};
